import { PartialTranslation } from '../translations';

export const id: PartialTranslation = {
  newChat: 'Obrolan Baru',
  search: 'Cari',
  user: 'Pengguna',
  settings: 'Pengaturan',
  language: 'Bahasa',
  getHelp: 'Dapatkan bantuan',
  viewAllPlans: 'Lihat semua paket',
  learnMore: 'Pelajari lebih lanjut',
  logOut: 'Keluar',
  chooseLanguage: 'Pilih Bahasa',
  chooseYourPreferredLanguage: 'Pilih bahasa yang Anda sukai',
  searchLanguages: 'Cari bahasa...',
  autoDetect: 'Deteksi Otomatis',
  noLanguagesFound: 'Tidak ada bahasa ditemukan',
  askAnything: 'Tanya apa saja',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Pribadi',
  freePlan: 'Paket gratis',
  current: 'Saat ini',
  close: 'Tutup',
  archive: 'Arsipkan',
  delete: 'Hapus',
  confirmDelete: 'Apakah Anda yakin ingin menghapus obrolan ini?',
  confirmArchive: 'Apakah Anda yakin ingin mengarsipkan obrolan ini?',
  deleteCannotUndo: 'Tindakan ini tidak dapat dibatalkan.',
  archiveCanFind: 'Anda dapat menemukannya di daftar arsip setelah pengarsipan.',
  resources: 'Sumber Daya',
  addResource: 'Tambah Sumber Daya',
  deleteResource: 'Hapus Sumber Daya',
  noMatchingResourcesFound: 'Tidak ada sumber daya yang cocok ditemukan',
  noResourcesAvailable: 'Tidak ada sumber daya tersedia',
  hideResources: 'Sembunyikan Sumber Daya',
  showResources: 'Tampilkan Sumber Daya',
  typeMessage: 'Ketik pesan...',
  thinkingOptions: 'Opsi pemikiran',
  deleteFile: 'Hapus file',
  clearSelection: 'Hapus pilihan',
  addAttachment: 'Tambah lampiran',
  sendMessage: 'Kirim pesan',
  deepInsight: 'Wawasan Mendalam · Analisis Permukaan',
  deepInsightDesc: 'Pemahaman cepat dari poin-poin kunci',
  deepExploration: 'Eksplorasi Mendalam · Analisis Komprehensif',
  deepExplorationDesc: 'Penelitian mendalam multi-dimensi',
  deepDeconstruction: 'Dekonstruksi Mendalam · Argumen Sistematis',
  deepDeconstructionDesc: 'Analisis progresif berlapis',
  contractReview: 'Tinjauan Kontrak · Identifikasi Risiko',
  contractReviewDesc: 'Analisis klausul dan pemeriksaan kepatuhan',
  textPolish: 'Poles Teks · Ekspresi Profesional',
  textPolishDesc: 'Optimasi bahasa dan penyesuaian struktur',
  legalDocuments: 'Dokumen Hukum · Draf Standar',
  legalDocumentsDesc: 'Penulisan dokumen hukum profesional',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Masuk',
  register: 'Daftar',
  welcomeBack: 'Selamat Datang di LawHelper',
  loginSubtitle: 'Asisten Penelitian Hukum AI Anda',
  continueWithGoogle: 'Lanjutkan dengan Google',
  continueWithMicrosoft: 'Lanjutkan dengan Microsoft',
  continueWithWeChat: 'Lanjutkan dengan WeChat',
  orContinueWith: 'atau lanjutkan dengan',
  emailTab: 'Email',
  phoneTab: 'Telepon',
  emailPlaceholder: 'Masukkan email Anda',
  phonePlaceholder: 'Masukkan nomor telepon',
  codePlaceholder: 'Masukkan kode 6 digit',
  sending: 'Mengirim...',
  verifying: 'Memverifikasi...',
  verify: 'Verifikasi',
  sendMagicLink: 'Kirim tautan ajaib',
  getVerificationCode: 'Dapatkan kode',
  resendCode: 'Kirim ulang kode',
  resendIn: 'Kirim ulang dalam',
  magicLinkSent: 'Tautan ajaib telah dikirim ke email Anda',
  magicLinkHint: 'Kami akan mengirimkan tautan aman ke email Anda',
  otpSent: 'Kode verifikasi telah dikirim',
  agreeToTerms: 'Dengan melanjutkan, Anda menyetujui',
  privacyPolicy: 'Kebijakan Privasi',
  termsOfService: 'Ketentuan Layanan',
  and: 'dan',
  privacyTitle: 'Privasi Anda penting',
  privacyIntro: 'Kami menggunakan cookie dan teknologi serupa untuk memberikan pengalaman terbaik.',
  essentialCookies: 'Cookie penting',
  essentialDesc: 'Diperlukan agar situs web berfungsi',
  analyticsCookies: 'Cookie analitik',
  analyticsDesc: 'Membantu kami meningkatkan layanan',
  marketingCookies: 'Cookie pemasaran',
  marketingDesc: 'Digunakan untuk konten yang dipersonalisasi',
  acceptAll: 'Terima semua',
  essentialOnly: 'Hanya penting',
  customize: 'Sesuaikan',
  savePreferences: 'Simpan preferensi',
  back: 'Kembali',
  readPrivacyPolicy: 'Baca kebijakan privasi kami',
  cookiePolicy: 'Kebijakan cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Tinjauan AI',
  aiDraft: 'Draf AI',
  smartAssistant: 'Templat',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktifkan pencarian',
  knowledgeSearchDesc: 'AI mencari di dokumen Anda',
  clickToDisable: 'Nonaktifkan',
  clickToEnable: 'Aktifkan',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Tutup panel sumber daya',
  uploading: 'Mengunggah %{fileName}...',
  processing: 'Memproses %{fileName}...',
  uploadSuccess: '✓ %{fileName} diunggah',
  uploadError: '✗ Gagal mengunggah: %{error}',
  quickAnswer: 'Jawaban Cepat',
  quickAnswerDesc: 'Jawaban cepat untuk pertanyaan sederhana',
  cancelRequest: 'Batal',
  library: 'Perpustakaan',
  filterAll: 'Semua',
  filterChat: 'Obrolan',
  filterReview: 'Tinjauan',
  filterDraft: 'Draf',
  filterTemplate: 'Templat',
  filterForm: 'Formulir',
  thinking: 'Berpikir...',
  thinkingProcess: 'Proses berpikir',
  analyzingLegalLogic: 'Menganalisis logika hukum...',
  lawhelperThinking: 'Lawhelper sedang berpikir...',
  serviceError: 'Kesalahan layanan',
  uploaded: 'Diunggah',
  settingsGeneral: 'Umum',
  settingsNotifications: 'Notifikasi',
  settingsAppearance: 'Tampilan',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Notifikasi respons',
  settingsResponseNotificationsDesc: 'Notifikasi saat respons AI selesai',
  settingsColorMode: 'Mode warna',
  settingsLight: 'Terang',
  settingsDark: 'Gelap',
  settingsSystem: 'Sistem',
  about: 'Tentang',
  reviewTitle: 'Tinjauan dokumen',
  exitReview: 'Keluar tinjauan',
  uploadPrompt: 'Unggah PDF untuk ditinjau',
  uploadButton: 'Pilih file',
  startChatConfig: 'Ketik "Tinjau dokumen ini"',
  reviewPlaceholder: 'Ketik pesan...',
  analyzing: 'Meninjau...',
  reviewComplete: 'Tinjauan selesai',
  issuesFound: 'Ditemukan %{count} masalah',
  draftTitle: 'Penyusunan dokumen hukum',
  draftPlaceholder: 'Edit di sini atau minta AI...',
  analyzingTemplate: 'Menganalisis templat %{name}...',
  templateAnalyzed: '✅ Templat %{name} dianalisis!',
  templateAnalysisPrompt: 'Analisis klausul utama',
  parsingFailed: '⚠️ Gagal menganalisis file.',
  generating: 'Membuat...',
  generatedSuccess: '✅ Dokumen dibuat!',
  drafterWelcome: 'Selamat datang di Asisten Dokumen AI',
  drafterYouCan: 'Anda dapat:',
  drafterUploadTemplate: 'Mengunggah templat untuk analisis AI',
  drafterDescribeNeeds: 'Menjelaskan kebutuhan dokumen',
  drafterLetAiHelp: 'AI membantu menyusun kontrak, perjanjian, dll.',
  drafterExamples: 'Contoh:',
  drafterExampleRental: '"Buat kontrak sewa"',
  drafterExampleLabor: '"Isi kontrak kerja"',
  drafterInputPlaceholder: 'Jelaskan kebutuhan Anda...',
  drafterThinking: 'Berpikir...',
  drafterHistoryTitle: 'Riwayat',
  drafterNoHistory: 'Tidak ada riwayat',
  drafterNewChat: 'Obrolan baru',
  drafterHistory: 'Riwayat',
  drafterRemoveAttachment: 'Hapus lampiran',
  drafterLineHeight: 'Tinggi baris',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Ekspor Word (.docx)',
  drafterExportPdf: 'Ekspor PDF',
  drafterSave: 'Simpan dokumen',
  drafterDownload: 'Unduh dokumen',
  drafterUndo: 'Batalkan',
  drafterRedo: 'Ulangi',
  drafterBold: 'Tebal',
  drafterItalic: 'Miring',
  drafterStrike: 'Coret',
  drafterUnderline: 'Garis bawah',
  drafterHighlight: 'Sorot',
  drafterLink: 'Sisipkan tautan',
  drafterAlignLeft: 'Rata kiri',
  drafterAlignCenter: 'Rata tengah',
  drafterAlignRight: 'Rata kanan',
  drafterAlignJustify: 'Rata kiri-kanan',
  drafterList: 'Daftar',
  drafterBulletList: 'Daftar poin',
  drafterOrderedList: 'Daftar bernomor',
  drafterTaskList: 'Daftar tugas',
  drafterOpenResource: 'Buka panel sumber daya',
  drafterStopGeneration: 'Hentikan pembuatan',
  drafterAgentMode: 'Mode Agent aktif',
  drafterAgentModeOn: 'Mode Agent aktif',
  drafterAgentModeOff: 'Mode normal',
  drafterUploadAttachment: 'Unggah lampiran',
  drafterExit: 'Keluar',
  drafterConfirm: 'Konfirmasi',
  drafterOpenLink: 'Buka tautan',
  drafterDeleteLink: 'Hapus tautan',
  drafterQuote: 'Kutipan',
  workflowTitle: 'Alur kerja AI',
  workflowRunning: 'Berjalan...',
  workflowReady: 'Siap',
  workflowCompleted: 'Selesai',
  workflowStartFailed: 'Gagal memulai alur kerja',
  workflowExecutionFailed: 'Eksekusi gagal',
  workflowInterrupted: 'Alur kerja terganggu',
  workflowProcessing: 'Memproses...',
  workflowStepsCompleted: 'langkah selesai',
  workflowStepsTotal: 'Alur kerja selesai (%{count} langkah)',
  acceptChanges: 'Terima perubahan',
  rejectChanges: 'Tolak perubahan',
  changesAccepted: 'Perubahan diterima',
  changesRejected: 'Perubahan ditolak',
  stopWorkflow: 'Hentikan',
  restartWorkflow: 'Mulai ulang',
  startDrafting: 'Mulai menyusun',
  interrupt: 'Hentikan',
  documentSubject: 'Subjek dokumen *',
  documentType: 'Jenis dokumen',
  jurisdiction: 'Yurisdiksi',
  specialRequirements: 'Persyaratan khusus (opsional)',
  clickStartDrafting: 'Klik "Mulai menyusun"',
  docTypeContract: 'Kontrak',
  docTypeAgreement: 'Perjanjian',
  docTypeNotice: 'Pemberitahuan',
  docTypeLetter: 'Surat',
  docTypePetition: 'Petisi',
  docTypeWill: 'Wasiat',
  docTypePowerOfAttorney: 'Surat kuasa',
  countryChina: 'Tiongkok',
  countryUSA: 'Amerika Serikat',
  countryGermany: 'Jerman',
  countryJapan: 'Jepang',
  countryFrance: 'Prancis',
  countryUK: 'Inggris Raya',
  citationVerified: 'Terverifikasi',
  citationUnverified: 'Belum terverifikasi',
  imageLoadFailed: 'Gagal memuat gambar',
  smartDocTitle: 'Asisten dokumen pintar',
  smartDocChatTitle: 'Asisten dokumen AI',
  smartDocDropPrompt: 'Letakkan file PDF di sini',
  smartDocSelectFile: 'Pilih file',
  smartDocOr: 'atau',
  smartDocWelcomeTitle: 'Selamat datang di Asisten AI',
  smartDocWelcomeYouCan: 'Anda dapat:',
  smartDocUploadForAI: 'Mengunggah templat',
  smartDocDescribeDoc: 'Menjelaskan kebutuhan',
  smartDocLetAIDraft: 'AI membantu kontrak',
  smartDocExamples: 'Contoh:',
  smartDocExampleRental: '"Buat kontrak sewa"',
  smartDocExampleLabor: '"Isi kontrak kerja"',
  smartDocInputPlaceholder: 'Jelaskan kebutuhan...',
  smartDocRemoveAttachment: 'Hapus lampiran',
  smartDocOpenResources: 'Buka sumber daya',
  smartDocExit: 'Keluar',
  reviewStartFailed: 'Gagal memulai tinjauan',
  reviewFailed: 'Tinjauan gagal',
  reviewFoundIssues: 'Tinjauan selesai, %{count} masalah.',
  cannotReadStream: 'Tidak dapat membaca stream',
  parseEventFailed: 'Gagal menganalisis peristiwa',
  errorPrefix: 'Kesalahan',
  unknownError: 'Kesalahan tidak dikenal',
  file: 'File',
  loading: 'Memuat...',
  localFolders: 'Folder lokal',
  selectLocalFolder: 'Pilih folder lokal',
  reselectFolder: 'Ganti folder',
  addToContext: 'Tambahkan ke obrolan',
  saveFile: 'Simpan',
  renameFile: 'Ganti nama',
  fileSaved: 'File disimpan',
  fileRenamed: 'File dinamai ulang menjadi %{name}',
  browserNotSupported: 'Browser tidak mendukung akses folder',
  noFolderSelected: 'Pilih folder lokal',
  scanningFolder: 'Memindai folder...',
  selectFileToPreview: 'Pilih file untuk pratinjau',
  aiAnalyze: 'Analisis AI',
};
